(function () {
  Flint.file("views/pages/sandboxPage.js", function (require) {
    Flint.view("SandboxPage", function (view, on, $) {
      var context = initContext(view, {
        isAdmin: atom()
      })

      // context.isAdmin.react(isAdmin => {
      //   if (isAdmin === false) {
      //     Flint.router.go('/')
      //   }
      // })

      ;view.render(function () {
        return Flint.iff(true || context.isAdmin.get()) && view.el(
          ["sandboxPage", 1],
          { if: true || context.isAdmin.get() },
          view.el(
            ["Loader", 1],
            null,
            view.el(
              ["c1", 1],
              null,
              "child 1"
            ),
            view.el(
              ["c2", 1],
              null,
              "child 2"
            )
          )
        );
      });
    });
  })
})();
//# sourceMappingURL=sandboxPage.js.map
